import type { InputHTMLAttributes } from 'react';
import { useId } from 'react';
import { cn } from '@/lib/cn';

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export function Input({
  label,
  value,
  onChange,
  error,
  type = 'text',
  className,
  id,
  ...rest
}: InputProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-text-primary">
          {label}
        </label>
      )}
      <input
        {...rest}
        id={inputId}
        type={type}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={Boolean(error) || undefined}
        className={cn(
          'h-12 w-full rounded-md border bg-background px-4 text-base text-text-primary',
          'placeholder:text-text-secondary',
          'transition-colors duration-150',
          error
            ? 'border-error focus-visible:outline-error'
            : 'border-border focus-visible:outline-primary',
          className,
        )}
      />
      {error && <p className="text-sm text-error">{error}</p>}
    </div>
  );
}
